import { FDSelect, Table } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import MetaField from 'facet-rest/src/domain/MetaField';
import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import { SelectInputSmall } from 'Packages/FacetDesign/Components';


const useStyles = buildUseStyles('MetaQueryFieldComponent', () => ({
  root: {
    width: ({ isMobile }) => (isMobile ? 'auto' : 200),
  },
}));

export default function MetaQueryFieldComponent({ metaQueryField, value, onChange }) {
  const isMobile = useMobileLayout();
  const classes = useStyles({ isMobile });

  function handlePicklistChange(e) {
    e.preventDefault();
    onChange(e.target.value, metaQueryField);
  }

  function handleMultipicklistChange(values) {
    // collapse the values into a comma separated list of values
    const listForQuery = values.join(',');
    onChange(listForQuery, metaQueryField);
  }

  function handleDateChange(newValue) {
    onChange(newValue, metaQueryField);
  }

  if (metaQueryField.attr('hidden')) return null;

  let component = null;

  if (metaQueryField.attr('type') === 'picklist') {
    component = (<FDSelect
      label={metaQueryField.attr('prompt')}
      options={metaQueryField.options()
        .list()
        .map(option => {
          return {
            label: option.attr('prompt'),
            value: option.attr('id'),
          };
        })}
      value={value}
      onChange={handlePicklistChange}
    />);
  }

  if (metaQueryField.attr('type') === 'multipicklist') {
    let list = [];
    if (value) {
      list = value.split(',').map(str => str.trim());
    }

    component = (<SelectInputSmall
      label={metaQueryField.attr('prompt')}
      options={metaQueryField.options()
        .list()
        .map(option => {
          return {
            prompt: option.attr('prompt'),
            id: option.attr('id'),
          };
        })}
      value={list}
      multiple
      prompt={metaQueryField.attr('prompt')}
      onChange={handleMultipicklistChange}
    />);
  }

  if (metaQueryField.attr('type') === 'date') {
    component = (<Table.FilterDateRange
      label={metaQueryField.attr('prompt')}
      value={value}
      onChange={handleDateChange}
    />);
  }

  if (component) {
    return (<div className={classes.root} data-test={`meta-query-field-${metaQueryField.attr('name')}`}>{component}</div>);
  }

  return null;
}
MetaQueryFieldComponent.defaultProps = {
  value: undefined,
};
MetaQueryFieldComponent.propTypes = {
  metaQueryField: PropTypes.instanceOf(MetaField).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
